import { render } from "./ClientsSection.vue?vue&type=template&id=510fe015&scoped=true"
import script from "./ClientsSection.vue?vue&type=script&lang=js"
export * from "./ClientsSection.vue?vue&type=script&lang=js"

import "./ClientsSection.vue?vue&type=style&index=0&id=510fe015&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510fe015"]])

export default __exports__